import Swiper from 'swiper';
import { A11y, Autoplay, Navigation, Pagination } from 'swiper/modules';

function parseSliderConfig(element) {
    const rawConfig = element.getAttribute('data-swiper-config');

    if (!rawConfig) {
        return {};
    }

    try {
        return JSON.parse(rawConfig);
    } catch (error) {
        return {};
    }
}

function prepareQuerySliderMarkup(element) {
    if (!element || !element.classList.contains('js-highfive-query-slider')) {
        return;
    }

    const config = parseSliderConfig(element);
    element.classList.add('swiper');

    const postTemplate = element.querySelector('.wp-block-post-template');

    if (postTemplate) {
        postTemplate.classList.add('swiper-wrapper');
    }

    element.querySelectorAll('.wp-block-post').forEach((post) => {
        post.classList.add('swiper-slide');
    });

    const existingPrev = element.querySelector('.hf-dynamic-slider__button--prev');
    const existingNext = element.querySelector('.hf-dynamic-slider__button--next');
    const existingPagination = element.querySelector('.hf-dynamic-slider__pagination');
    let navigationWrapper = element.querySelector('.hf-dynamic-slider__nav');

    if (config.navigation) {
        if (!navigationWrapper) {
            navigationWrapper = document.createElement('div');
            navigationWrapper.className = 'hf-dynamic-slider__nav';
            element.appendChild(navigationWrapper);
        }

        if (!existingPrev) {
            const prevButton = document.createElement('button');
            prevButton.type = 'button';
            prevButton.className = 'hf-dynamic-slider__button hf-dynamic-slider__button--prev';
            prevButton.setAttribute('aria-label', 'Slide precedente');
            navigationWrapper.appendChild(prevButton);
        }

        if (!existingNext) {
            const nextButton = document.createElement('button');
            nextButton.type = 'button';
            nextButton.className = 'hf-dynamic-slider__button hf-dynamic-slider__button--next';
            nextButton.setAttribute('aria-label', 'Slide suivante');
            navigationWrapper.appendChild(nextButton);
        }
    } else {
        existingPrev?.remove();
        existingNext?.remove();
        navigationWrapper?.remove();
    }

    if (config.pagination) {
        if (!existingPagination) {
            const pagination = document.createElement('div');
            pagination.className = 'hf-dynamic-slider__pagination';
            element.appendChild(pagination);
        }
    } else {
        existingPagination?.remove();
    }
}

function initSlider(element) {
    if (!element) {
        return;
    }

    prepareQuerySliderMarkup(element);

    if (element.dataset.swiperInitialized === 'true' && element.highfiveSwiper) {
        element.highfiveSwiper.update();
        return;
    }

    const swiperElement = element.matches('.swiper') ? element : element.querySelector('.swiper');

    if (!swiperElement) {
        return;
    }

    const config = parseSliderConfig(element);
    const isQuerySlider = element.classList.contains('js-highfive-query-slider');
    const prevButton = element.querySelector('.hf-dynamic-slider__button--prev');
    const nextButton = element.querySelector('.hf-dynamic-slider__button--next');
    const swiperConfig = {
        ...config,
    };
    const paginationType = config.paginationType === 'numbers' ? 'bullets' : (config.paginationType || 'bullets');

    delete swiperConfig.navigation;
    delete swiperConfig.pagination;
    delete swiperConfig.autoplay;
    delete swiperConfig.loop;
    delete swiperConfig.spaceBetween;
    delete swiperConfig.breakpoints;

    const instance = new Swiper(swiperElement, {
        modules: [Navigation, Pagination, A11y, Autoplay],
        watchOverflow: true,
        observer: true,
        observeParents: true,
        wrapperClass: isQuerySlider ? 'wp-block-post-template' : 'swiper-wrapper',
        slideClass: isQuerySlider ? 'wp-block-post' : 'swiper-slide',
        navigation: config.navigation
            ? {
                nextEl: nextButton,
                prevEl: prevButton,
            }
            : false,
        pagination: config.pagination
            ? {
                el: element.querySelector('.hf-dynamic-slider__pagination'),
                clickable: true,
                type: paginationType,
                renderBullet:
                    config.paginationType === 'numbers'
                        ? function (index, className) {
                            return `<button class="${className} hf-dynamic-slider__pagination-number" type="button">${index + 1}</button>`;
                        }
                        : undefined,
            }
            : false,
        autoplay: config.autoplay || false,
        loop: !!config.loop,
        spaceBetween: Number(config.spaceBetween || 0),
        slidesPerGroup: Math.max(1, Number(config.slidesPerGroup || 1)),
        breakpoints: config.breakpoints || {},
        a11y: {
            enabled: true,
            prevSlideMessage: 'Slide precedente',
            nextSlideMessage: 'Slide suivante',
            firstSlideMessage: 'Ceci est la premiere slide',
            lastSlideMessage: 'Ceci est la derniere slide',
            paginationBulletMessage: 'Aller a la slide {{index}}',
            slideLabelMessage: '{{index}} sur {{slidesLength}}',
            // Ne pas ecraser le role "listitem" implicite des <li> (requis par
            // le role="list" pose sur le wrapper) avec le role="group" par
            // defaut de Swiper.
            slideRole: null,
        },
        ...swiperConfig,
    });

    [ prevButton, nextButton ].forEach( ( button ) => {
        if ( ! button ) {
            return;
        }

        button.addEventListener( 'mousedown', ( event ) => {
            event.preventDefault();
            event.stopPropagation();
        } );

        button.addEventListener( 'click', ( event ) => {
            event.preventDefault();
            event.stopPropagation();
        } );
    } );

    element.dataset.swiperInitialized = 'true';
    element.highfiveSwiper = instance;
}

export function initHighfiveDynamicSliders(root = document) {
    const sliders = root.querySelectorAll('.js-highfive-dynamic-slider, .js-highfive-query-slider');

    sliders.forEach(initSlider);
}
